/* eslint-disable no-unused-vars */
import React, { useState, useRef } from 'react';

import { OffersAndEventsFiltering, HeadingTag } from '@/components';
import GridCard from '@/components/cards/GridCard';
import { isColorDark } from '@/utils';
import cn from 'classnames';
import { useTranslation } from 'next-i18next';

const CardListingGridOfferAndEvent = ({ data }) => {
  const [loading, setLoading] = useState(false);
  const [cards] = useState(data.filtersAndCards.cards); // Take cards from data
  const [activeCategory, setActiveCategory] = useState(null);
  const [displayedCards, setDisplayedCards] = useState(data.filtersAndCards.pageSize);
  const [loadingMore, setLoadingMore] = useState(false);
  const cardContainerRef = useRef(null);
  const isDark = isColorDark(data.backgroundColour);
  const { t } = useTranslation('common');

  const filteredCards = activeCategory ? cards.filter((card) => card.props.category === activeCategory) : cards;

  const slicedCards = filteredCards.slice(0, displayedCards);

  const setPagedCards = () => {
    setLoadingMore(true);

    setTimeout(() => {
      setDisplayedCards((prev) => prev + data.filtersAndCards.pageSize);
      setLoadingMore(false);
    }, 500);
  };

  const classByCardsPerRow = (cardsPerRow) => {
    switch (cardsPerRow) {
      case 1:
        return 'xxl:grid-cols-1';
      case 2:
        return 'xxl:grid-cols-2';
      case 3:
        return data.filtersAndCards.cardType === 'Article' ? 'xxl:grid-cols-3' : 'xl:grid-cols-3 xl:w-[1110px]';
      default:
        return 'xxl:grid-cols-3';
    }
  };

  return (
    <>
      <div className="text-wrapper container lg:flex lg:justify-between mb-6 lg:mb-[71px]">
        <div className="title-wrapper lg:max-w-[511px]">
          {data.preHeading && <p className="color-from-bg text-paragraph-m leading-4">{data.preHeading}</p>}
          {data.headingTitle && (
            <HeadingTag
              data={data.headingTitle}
              className="heading-title color-from-bg title font-ivy-ora text-secondary-coolsand my-4 text-t4 lg:text-[44px] lg:leading-[48px]"
            />
          )}
        </div>

        {data.description && (
          <div className="description-wrapper lg:max-w-[431px]">
            <p className="color-from-bg lg:mt-8 text-large-paragraph">{data.description}</p>
          </div>
        )}
      </div>

      {cards && data?.filtersAndCards?.types && (
        <div className="w-full flex justify-between container">
          <OffersAndEventsFiltering
            backgroundColour={data.backgroundColour}
            data={data.filtersAndCards}
            filteredCardsLength={filteredCards.length}
            slicedCardsLength={slicedCards.length}
            queryMode
            className="mb-[44px] w-full sm:w-fit"
            setActiveCategory={setActiveCategory}
          />

          {data.filtersAndCards.showFilters && (
            <div className="showing-wrapper-desktop hidden sm:block pt-4">
              <div
                className={cn(
                  'font-cera text-tag-m not-italic font-normal leading-24',
                  isDark ? 'text-white' : 'text-primary',
                )}
              >
                {t('map.$showingXofX', { showing: slicedCards.length, total: filteredCards.length })}
              </div>
            </div>
          )}
        </div>
      )}

      <div
        className={`container ${data.filtersAndCards.cardType === 'Article' ? 'px-[15.5px] m-auto' : ''} transition-opacity duration-500 ${loading ? 'opacity-0' : 'opacity-100'}`}
      >
        <div
          ref={cardContainerRef}
          className={`flex flex-col md:grid auto-rows-fr md:auto-rows-auto w-auto md:w-[724px] lg:w-[960px] xl:w-[1200px] xxl:w-[1356px] m-auto grid-cols-1 md:grid-cols-2 ${classByCardsPerRow(data.cardsPerRow)} ${data.filtersAndCards.cardType === 'Article' ? 'gap-4 md:!w-[625px] lg:!w-[932px] xxl:!w-full' : 'gap-6 lg:gap-10'} xxl:justify-between`}
        >
          {slicedCards.map((card) =>
            card ? (
              <GridCard
                key={card.moduleId}
                data={card}
                cardsPerRow={data.cardsPerRow}
                cardType={data.filtersAndCards.cardType}
              />
            ) : null,
          )}
        </div>

        {filteredCards.length > displayedCards && (
          <button
            className={cn(
              'mt-10 border block !mx-auto h-[44px] transition cursor-pointer font-cera text-tag-m not-italic font-normal leading-24 px-4 bordertransition',
              isDark ? 'border-secondary-coolsand text-white' : 'border-primary text-primary',
            )}
            onClick={setPagedCards}
          >
            {loadingMore ? 'Loading...' : 'Load More'}
          </button>
        )}
      </div>
    </>
  );
};

export default CardListingGridOfferAndEvent;
